export default __webpack_public_path__ + "static/media/spheron-logo.62185709.svg";